import indicationApiService from '../../api/indications';

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export default {
  getJobsIRecommendedPerson: async ({ state, commit }, { email, force = true }) => {
    const key = `person_${email}`;
    const cachedJobsRecommendedPerson = state.cachedJobsRecommendedPerson[key];

    if (!force && cachedJobsRecommendedPerson) {
      commit('SET_JOBS_RECOMMENDED_PERSON', cachedJobsRecommendedPerson);
      return cachedJobsRecommendedPerson;
    }

    const { data } = await indicationApiService.getJobsIRecommendedPerson({ email });
    if (!data) return [];
    commit('SET_JOBS_RECOMMENDED_PERSON', data);
    commit('CACHE_JOBS_RECOMMENDED_PERSON', { key, data });

    return data;
  },
  getRecommendationsByJob: async ({ state, commit }, { email, jobId, force = true }) => {
    const key = `person_${email}_job_${jobId}`;
    const cachedRecommendationsByJob = state.cachedRecommendationsByJob[key];

    if (!force && cachedRecommendationsByJob) {
      commit('SET_RECOMMENDATION_BY_JOB', cachedRecommendationsByJob);
      return cachedRecommendationsByJob;
    }

    const { data } = await indicationApiService.getRecommendationsByJob({ email, jobId });
    if (!data) return [];
    commit('SET_RECOMMENDATIONS_BY_JOB', data);
    commit('CACHE_RECOMMENDATIONS_BY_JOB', { key, data });

    return data;
  },
  getIndicationsByJobId: async ({ state, commit }, { jobId, companyEmail = '', force = true }) => {
    const key = `indications_job_${jobId}`;
    const cachedIndicationsByJobId = state.cachedIndicationsByJobId[key];

    if (!force && cachedIndicationsByJobId) {
      commit('SET_INDICATIONS_BY_JOB_ID', cachedIndicationsByJobId);
      return cachedIndicationsByJobId;
    }

    const { data } = await indicationApiService.getIndicationsByJobId({ jobId, companyEmail });
    if (!data) return [];
    commit('SET_INDICATIONS_BY_JOB_ID', data);
    commit('CACHE_INDICATIONS_BY_JOB_ID', { key, data });

    return data;
  },
  getJobsIWasIndicatedPerson: async ({ state, commit }, { email, force = true }) => {
    const key = `person_indicated_${email}`;
    const cachedJobsRecommendedPerson = state.cachedJobsRecommendedPerson[key];

    if (!force && cachedJobsRecommendedPerson) {
      commit('SET_JOBS_I_WAS_INDICATED_PERSON', cachedJobsRecommendedPerson);
      return cachedJobsRecommendedPerson;
    }

    const { data } = await indicationApiService.getJobsIWasIndicatedPerson({ email });
    if (!data) return [];
    commit('SET_JOBS_I_WAS_INDICATED_PERSON', data);
    commit('CACHE_JOBS_I_WAS_INDICATED_PERSON', { key, data });

    return data;
  },
  getIndicationsIReceivedByJob: async ({ state, commit }, { email, jobId, force = true }) => {
    const key = `person_indicated_${email}_job_${jobId}`;
    const cachedRecommendationsByJob = state.cachedRecommendationsByJob[key];

    if (!force && cachedRecommendationsByJob) {
      commit('SET_INDICATIONS_I_RECEIVED_BY_JOB', cachedRecommendationsByJob);
      return cachedRecommendationsByJob;
    }

    const { data } = await indicationApiService.getIndicationsIReceivedByJob({ email, jobId });
    if (!data) return [];
    commit('SET_INDICATIONS_I_RECEIVED_BY_JOB', data);
    commit('CACHE_INDICATIONS_I_RECEIVED_BY_JOB', { key, data });

    return data;
  },
};
